










import Vue from 'vue';
import ItemGoggle from '@/components/ItemGoggle.vue';

export default Vue.extend({
    components: {
        ItemGoggle,
    },

    computed: {
        goggle() {
            return this.$store.state.goggle;
        },
    },

    created() {
        this.$store.dispatch('loadGoggle');
    },

});
